import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch, AiOutlineBarChart } from "react-icons/ai";
import '../../css/reports-v2.css'
import '../../css/dashboard.css'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import { DeleteCharactersNotAccepted, ItemDesc, ItemDescV2, MonthInLetters, NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { getIndexElement } from '../../functions/searchInObject'
import { pricesFormat } from '../../functions/pricesFormat';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from '../../components/LoadingWindow';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet, getDataSetSales, getDataSetSales2 } from '../../functions/generateDataSetExcel';
import ModalOrders from '../../components/ModalComponent';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLines } from '../../functions/dateFormat';
import { confirmCloseAlert } from '../../functions/alerts';
import { Menu } from '../../components/Menu/Menu';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/* ---- Chart options ---- */
const monthlyChartOptions = {
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) =>
                    ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        y: {
            ticks: {
                callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }),
            },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        x: { grid: { display: false } },
    },
};

const topItemsChartOptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) =>
                    ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        x: {
            ticks: {
                callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }),
            },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        y: { grid: { display: false } },
    },
};

export default class Sales extends Component {
    constructor(props) {
        super(props)
        this.BarGraph1 = React.createRef()
        this.ModalLoading = React.createRef();
    }

    state = {
        HeaderTable: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        HeaderTable2: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        BodyCustomer: [],
        BodyFilterCustomer: [],
        Body: [],
        BodyFilter: [],
        AllInformation: [],
        Totals: [],
        showModal1: false,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        currentCustomer: {
            CustomerNo: '',
            CustomerName: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        AllNoProccessInformation: [],
        ShortDetail: [],
        CustomerDetail: [],
        ShortDetailWithTotal: [],
        flag: true,
        Mode: 1,
        CustomerList: [],
    }

    /* ------------------------------------------------------------------ */
    /*  Data loading & processing (unchanged)                               */
    /* ------------------------------------------------------------------ */

    TableHeader(splitStartDate, splitEndDate) {
        let years = [{ year: '', span: 6 }]
        let years2 = [{ year: '', span: 9 }]
        let months = []
        let General = [{ year: '', month: '', title: ['   No   ', 'Item Code', 'Product Line', 'Description', 'Category', 'Subcategory'] }]
        let General2 = [{ year: '', month: '', title: ['   No   ', 'Customer No', 'Customer Name', 'Address', 'City', 'State', 'Zip Code'] }]

        for (let a = Number(splitStartDate[0]); a <= Number(splitEndDate[0]); a++) {
            if (a === Number(splitStartDate[0]) && a === Number(splitEndDate[0])) {
                var cont1 = 0
                for (let b = Number(splitStartDate[1]); b <= Number(splitEndDate[1]); b++) {
                    cont1++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont1 * 3 }
                years.push(temp)
                years2.push(temp)
                break
            } else if (a === Number(splitStartDate[0])) {
                var cont2 = 0
                for (let b = Number(splitStartDate[1]); b <= 12; b++) {
                    cont2++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont2 * 3 }
                years.push(temp)
                years2.push(temp)
            } else if (a === Number(splitEndDate[0])) {
                var cont3 = 0
                for (let b = 1; b <= Number(splitEndDate[1]); b++) {
                    cont3++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont3 * 3 }
                years.push(temp)
                years2.push(temp)
            } else {
                for (let b = 1; b <= 12; b++) {
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: 12 * 3 }
                years.push(temp)
                years2.push(temp)
            }
        }

        this.setState({
            HeaderTable: { Row1: years, Row2: months, Row3: General },
            HeaderTable2: { Row1: years2, Row2: months, Row3: General2 }
        })
    }

    clearAll() {
        this.setState({
            HeaderTable: { Row1: [], Row2: [], Row3: [] },
            Body: [],
            BodyFilter: [],
            AllInformation: [],
            Totals: [],
            currentItem: { ItemCode: '', ItemCodeDesc: '', ProductLine: '', itemURL: '' },
            AllNoProccessInformation: [],
            ShortDetail: [],
        })
    }

    async getCustomerData() {
        const data = { SalespersonNo: '0000' }
        const response = await getInformationWithData('/customer/getList', data)
        const customers = response.data
        this.setState({ CustomerList: customers });
        return customers;
    }

    async addCustomerData(data) {
        const customers = await this.getCustomerData()
        const dataWCustomer = data.map(item => {
            const customer = customers.find(c => c.customerNo === item.CustomerNo);
            if (customer) {
                return {
                    ...item,
                    AddressLine1: customer.addressLine1,
                    City: customer.city,
                    State: customer.state,
                    ZipCode: customer.zipCode
                };
            }
            return item;
        });
        return dataWCustomer;
    }

    async getShorts() {
        this.ModalLoading.current.showState(true);
        this.clearAll()
        var date1 = document.getElementById('startSalesFilterDate').value
        var date2 = document.getElementById('endSalesFilterDate').value
        const splitStartDate = date1.split('-')
        const splitEndDate = date2.split('-')
        if (splitStartDate.length === 3 && splitEndDate.length === 3) {
            this.TableHeader(splitStartDate, splitEndDate)
            const data = {
                Start: date1,
                End: date2,
                idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId'))
            }
            let result = await getInformationWithData('/invoice/report/SalesV2', data)
            const parsedNumbers = (obj) => ({
                ...obj,
                UnitPrice: Number(obj.UnitPrice),
                UnitCost: Number(obj.UnitCost),
                QuantityOrdered: Number(obj.QuantityOrdered),
                QuantityShipped: Number(obj.QuantityShipped),
                shorts: Number(obj.shorts),
                SalesOrderNo: obj.SalesOrderNo ? obj.SalesOrderNo : ''
            })

            const updatedParsedData = result.data.map(parsedNumbers);
            result.data = updatedParsedData;

            let temporal = []
            let customer = []
            if (result.status.code === 1) {
                const AllInformationWCustomer = await this.addCustomerData(result.data);
                this.setState({ AllInformation: AllInformationWCustomer })

                for (const item of AllInformationWCustomer) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    const index2 = getIndexElement(customer, 'CustomerNo', item.CustomerNo)
                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []

                    if (index === -1 && splitDate.length === 3) {
                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Category: item.Category,
                            Subcategory: item.Subcategory,
                            Detail: []
                        }
                        const year = { year: String(splitDate[0]), Months: [] }
                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = { year: String(splitDate[0]), Months: [] }
                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            } else {
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }
                    }

                    if (index2 === -1 && splitDate.length === 3) {
                        const json = {
                            CustomerNo: item.CustomerNo,
                            CustomerName: item.BillToName,
                            AddressLine1: item.AddressLine1,
                            City: item.City,
                            State: item.State,
                            ZipCode: item.ZipCode,
                            Detail: []
                        }
                        const year = { year: String(splitDate[0]), Months: [] }
                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        customer.push(json)
                    } else if (splitDate.length === 3) {
                        const element = customer[index2]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = { year: String(splitDate[0]), Months: [] }
                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            } else {
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            }
                        }
                    }
                }

                for (const month of this.state.HeaderTable.Row2) {
                    for (const item of temporal) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal2 = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal2.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal2.Months.push(add2)
                                item.Detail[indexyear] = temporal2
                            }
                        }
                    }

                    for (const item of customer) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal2 = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal2.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal2.Months.push(add2)
                                item.Detail[indexyear] = temporal2
                            }
                        }
                    }
                }

                temporal = this.Order(temporal, 'ItemCode', true)
                customer = this.Order(customer, 'CustomerNo', true)
                const customers = this.state.CustomerList;
                customer = customer.map(item => {
                    const c = customers.find(c => c.CustomerNo === item.CustomerNo);
                    if (c) {
                        return { ...item, Address: c.AddressLine1 || '', City: c.City || '', State: c.State || '', ZipCode: c.ZipCode || '' };
                    }
                    return item;
                });

                temporal = await ItemDescV2(temporal, 'ItemCodeDesc', 'ItemCode')
                for (const item of temporal) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                for (const item of customer) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                await this.setState({ BodyCustomer: customer, BodyFilterCustomer: customer, Body: temporal, BodyFilter: temporal, Totals: this.getTotals(temporal), AllNoProccessInformation: result.data })
            }
        } else {
            confirmCloseAlert('incorrect', 'Both dates must be established\n to make the report!')
        }
        this.ModalLoading.current.showState(false);
    }

    /* ------------------------------------------------------------------ */
    /*  Search & sort helpers (unchanged)                                   */
    /* ------------------------------------------------------------------ */

    contains = (parametro, busqueda) => {
        if (!parametro) return false;
        return parametro.toString().toLowerCase().includes(busqueda.toLowerCase());
    }

    searchShorts = e => {
        const search = e.target.value.toLowerCase();
        const { Body } = this.state;
        const orders = Body.filter(item =>
            this.contains(item.ItemCode, search) ||
            this.contains(item.ProductLine, search) ||
            this.contains(item.ItemCodeDesc, search)
        );
        this.setState({ BodyFilter: orders, Totals: this.getTotals(orders) });
    }

    searchShorts2 = e => {
        const search = e.target.value;
        const { BodyCustomer } = this.state;
        const orders = BodyCustomer.filter(item =>
            this.contains(item.CustomerNo, search) ||
            this.contains(item.CustomerName, search)
        );
        this.setState({ BodyFilterCustomer: orders, Totals: this.getTotals(orders) });
    }

    getTotals(temporal) {
        let totals = []
        let flag = true
        let count = 0
        for (const item of temporal) {
            for (const detail of item.Detail) {
                for (let a = 0; a < detail.Months.length; a++) {
                    if (flag) {
                        totals.push(detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped))
                        totals.push('$')
                        totals.push(detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts))
                    } else {
                        totals[count] += detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped)
                        count += 2
                        totals[count] += detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts)
                        count += 1
                    }
                }
            }
            flag = false
            count = 0
        }
        for (let num = 0; num < totals.length; num++) {
            if (totals[num] !== '$') {
                totals[num] = NumberFormat(pricesFormat(totals[num]))
            }
        }
        return totals
    }

    Order(arreglo, llave, bandera) {
        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }

    handleModalOpen = (modal) => { this.setState({ [modal]: true }) }
    handleModalClose = (modal) => { this.setState({ [modal]: false }) }

    clearOnlyShortDetail() {
        this.setState({
            currentItem: { ItemCode: '', ItemCodeDesc: '', ProductLine: '', itemURL: '', totalShorts: 0, totalQuantityShipped: 0, totalQuantityOrdered: 0, totalShort: 0 },
            ShortDetail: [],
            currentCustomer: { CustomerNo: '', CustomerName: '', totalShorts: 0, totalQuantityShipped: 0, totalQuantityOrdered: 0, totalShort: 0 },
            CustomerDetail: [],
        })
    }

    async DetailofShort(itemCode) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentItem
        temporal.ItemCode = itemCode.ItemCode
        temporal.ItemCodeDesc = itemCode.ItemCodeDesc
        temporal.ProductLine = itemCode.ProductLine
        temporal.Category = itemCode.Category
        temporal.Subcategory = itemCode.Subcategory

        let SpecificDetail = []
        var total = 0, totalShipped = 0, totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.ItemCode === itemCode.ItemCode) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }
        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()
        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')

        const data = { idCompany: Number(getValueCookie('CompanyId')), ItemCode: itemCode.ItemCode }
        const resultImg = await getInformationWithData('/Items/get/Img', data)
        if (resultImg.status.code === 1 && resultImg.data.itemURLImage) {
            temporal.itemURL = resultImg.data.itemURLImage !== '' ? `${resultImg.data.itemURLImage}?${new Date().getTime()}` : ''
        } else {
            temporal.itemURL = ''
        }

        await this.setState({ ShortDetail: SpecificDetail, currentItem: temporal })
        var totalRow = { InvoiceDate: 'TOTAL', QuantityShipped: totalShipped, QuantityOrdered: totalOrdered, TotalShortD: '$' + pricesFormat(total) }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async DetailbyCustomer(info) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentCustomer
        temporal.CustomerNo = info.CustomerNo
        temporal.CustomerName = info.CustomerName

        let SpecificDetail = []
        var total = 0, totalShipped = 0, totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.CustomerNo === info.CustomerNo) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }
        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()
        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')

        await this.setState({ CustomerDetail: SpecificDetail, currentCustomer: temporal })
        var totalRow = { InvoiceDate: 'TOTAL', QuantityShipped: totalShipped, QuantityOrdered: totalOrdered, TotalShortD: '$' + pricesFormat(total) }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async OrderPriceMargins(option, pos) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "Item Code":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Product Line":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilter: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilter: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async OrderPriceMargins2(option, pos) {
        var temporal = this.state.BodyFilterCustomer
        switch (option) {
            case "Customer No":
                temporal = OrderArray(temporal, "CustomerNo", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Customer Name":
                temporal = OrderArray(temporal, "CustomerName", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Address":
                temporal = OrderArray(temporal, "AddressLine1", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "City":
                temporal = OrderArray(temporal, "City", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "State":
                temporal = OrderArray(temporal, "State", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Zip Code":
                temporal = OrderArray(temporal, "ZipCode", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilterCustomer: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilterCustomer: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async orderShorts(array, conditions, key) {
        const l = array.length
        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {
                const pos1 = await getIndexElement(array[j].Detail, 'year', conditions.year)
                const pos2 = await getIndexElement(array[j].Detail[pos1].Months, 'month', conditions.month)
                const pos3 = await getIndexElement(array[j + 1].Detail, 'year', conditions.year)
                const pos4 = await getIndexElement(array[j + 1].Detail[pos3].Months, 'month', conditions.month)
                const m = array[j].Detail[pos1].Months[pos2][key] === '-' ? 0 : Number(array[j].Detail[pos1].Months[pos2][key])
                const n = array[j + 1].Detail[pos3].Months[pos4][key] === '-' ? 0 : Number(array[j + 1].Detail[pos3].Months[pos4][key])
                if (this.state.flag) {
                    if (m > n) [array[j], array[j + 1]] = [array[j + 1], array[j]];
                } else {
                    if (m < n) [array[j], array[j + 1]] = [array[j + 1], array[j]];
                }
            }
        }
        return array
    }

    /* ------------------------------------------------------------------ */
    /*  KPI & chart data helpers                                            */
    /* ------------------------------------------------------------------ */

    getKPIs() {
        const data = this.state.AllNoProccessInformation;
        if (!data.length) return null;
        const totalRevenue = data.reduce((s, r) => s + r.shorts, 0);
        const totalUnits   = data.reduce((s, r) => s + r.QuantityShipped, 0);
        const uniqueItems  = new Set(data.map(r => r.ItemCode)).size;
        const totalCost    = data.reduce((s, r) => s + (r.UnitCost * r.QuantityShipped), 0);
        const avgMargin    = totalRevenue > 0 ? ((totalRevenue - totalCost) / totalRevenue * 100) : 0;
        return { totalRevenue, totalUnits, uniqueItems, avgMargin };
    }

    getMonthlyChartData() {
        const data = this.state.AllNoProccessInformation;
        const map = {};
        for (const row of data) {
            if (!row.InvoiceDate) continue;
            const parts = row.InvoiceDate.split('-');
            if (parts.length < 2) continue;
            const key = `${parts[0]}-${parts[1]}`;
            map[key] = (map[key] || 0) + row.shorts;
        }
        const sorted = Object.keys(map).sort();
        return {
            labels: sorted.map(k => {
                const [y, m] = k.split('-');
                return MonthInLetters(Number(m)) + ' ' + y;
            }),
            datasets: [{
                label: 'Revenue',
                data: sorted.map(k => map[k]),
                backgroundColor: 'rgba(37, 99, 235, 0.82)',
                hoverBackgroundColor: 'rgba(29, 78, 216, 0.92)',
                borderRadius: 5,
            }],
        };
    }

    getTopItemsChartData() {
        const data = this.state.AllNoProccessInformation;
        const map = {};
        for (const row of data) {
            if (!row.ItemCode) continue;
            if (!map[row.ItemCode]) {
                map[row.ItemCode] = {
                    label: row.ItemCode,
                    value: 0,
                };
            }
            map[row.ItemCode].value += row.shorts;
        }
        const palette = [
            'rgba(37,99,235,0.82)', 'rgba(16,185,129,0.82)', 'rgba(245,158,11,0.82)',
            'rgba(139,92,246,0.82)', 'rgba(239,68,68,0.82)', 'rgba(14,165,233,0.82)',
            'rgba(234,179,8,0.82)', 'rgba(168,85,247,0.82)', 'rgba(34,197,94,0.82)',
            'rgba(249,115,22,0.82)',
        ];
        const sorted = Object.values(map).sort((a, b) => b.value - a.value).slice(0, 10);
        return {
            labels: sorted.map(i => i.label),
            datasets: [{
                label: 'Revenue ($)',
                data: sorted.map(i => i.value),
                backgroundColor: sorted.map((_, idx) => palette[idx % palette.length]),
                borderRadius: 4,
            }],
        };
    }

    /* ------------------------------------------------------------------ */
    /*  Render                                                               */
    /* ------------------------------------------------------------------ */

    render() {
        const hasData = this.state.AllNoProccessInformation.length > 0;
        const kpis = hasData ? this.getKPIs() : null;
        const { Mode } = this.state;

        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
        const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' };

        return (
            <div className="dash-page" style={{ }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{  marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineBarChart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Sales Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Analyze sales by item or customer across any date range</p>
                    </div>
                    {hasData && (
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.AllNoProccessInformation.length.toLocaleString('en-US')} records
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Controls */}
                    <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Date Range</span>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="startSalesFilterDate">Start Date</label>
                                    <input style={inputStyle} id="startSalesFilterDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="endSalesFilterDate">End Date</label>
                                    <input style={inputStyle} id="endSalesFilterDate" type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button onClick={() => this.getShorts()} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center' }}>
                                        <AiOutlineReload /> Load Data
                                    </button>
                                </div>
                                {hasData && (
                                    <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                        {Mode === 1 ? (
                                            <ExcelDocument
                                                archname={'Sales ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname2={['Sales Detail ' + getValueCookie('Company')]}
                                                sheetname={'Sales ' + getValueCookie('Company')}
                                                data={getDataSetSales(this.state.HeaderTable.Row1, this.state.HeaderTable.Row2, this.state.HeaderTable.Row3, this.state.Body, this.state.Totals)}
                                                data2={[getDataSet(this.state.AllInformation,
                                                    ['Item Code', 'Product Line', 'Description', 'Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Category', 'Subcategory', 'Unit Price ($)', 'Unit Cost', 'Price Margin', 'Total Sales ($)'],
                                                    ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'Category', 'Subcategory', 'UnitPrice', 'UnitCost', 'PriceMargin', 'shorts']
                                                )]}
                                            />
                                        ) : (
                                            <ExcelDocument
                                                archname={'Sales ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname2={['Sales Detail ' + getValueCookie('Company')]}
                                                sheetname={'Sales ' + getValueCookie('Company')}
                                                data={getDataSetSales2(this.state.HeaderTable2.Row1, this.state.HeaderTable2.Row2, this.state.HeaderTable2.Row3, this.state.BodyCustomer, this.state.Totals)}
                                                data2={[getDataSet(this.state.AllInformation,
                                                    ['Item Code', 'Product Line', 'Description', 'Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Price ($)', 'Total Sales ($)', 'Address', 'City', 'State', 'Zip Code'],
                                                    ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPrice', 'shorts', 'AddressLine1', 'City', 'State', 'ZipCode']
                                                )]}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* KPIs */}
                    {hasData && kpis && (
                        <div className="row g-3 mb-3">
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Total Revenue</div>
                                    <div className="metric-value">${NumberFormat(pricesFormat(kpis.totalRevenue))}</div>
                                    <div className="metric-change">Period total</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-success">
                                    <div className="metric-label">Units Shipped</div>
                                    <div className="metric-value">{Math.round(kpis.totalUnits).toLocaleString('en-US')}</div>
                                    <div className="metric-change">Total units</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Unique Items</div>
                                    <div className="metric-value">{kpis.uniqueItems.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Distinct SKUs</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-warning">
                                    <div className="metric-label">Avg Margin</div>
                                    <div className="metric-value">{pricesFormat(kpis.avgMargin)}%</div>
                                    <div className="metric-change">Weighted avg</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Charts */}
                    {hasData && (
                        <div className="row g-3 mb-3">
                            <div className="col-md-8">
                                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Revenue by Month</span>
                                    </div>
                                    <div className="card-body">
                                        <Bar data={this.getMonthlyChartData()} options={monthlyChartOptions} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Top 10 Items by Revenue</span>
                                    </div>
                                    <div className="card-body">
                                        <Bar data={this.getTopItemsChartData()} options={topItemsChartOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Table card */}
                    {hasData && (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                                <div style={{ display: 'flex', gap: '0.4rem' }}>
                                    {[{ id: 1, label: 'Item List' }, { id: 2, label: 'Customer List' }].map(t => (
                                        <button key={t.id}
                                            onClick={() => this.setState({ Mode: t.id, Totals: this.getTotals(t.id === 1 ? this.state.BodyFilter : this.state.BodyFilterCustomer) })}
                                            style={{ padding: '0.3rem 0.875rem', borderRadius: '6px', fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer', border: 'none', background: Mode === t.id ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)', color: 'white' }}>
                                            {t.label}
                                        </button>
                                    ))}
                                </div>
                                <div style={{ position: 'relative', minWidth: '240px' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input type="text" autoComplete="off"
                                        placeholder={Mode === 1 ? 'Search item code, line, description…' : 'Search customer no, name…'}
                                        onChange={Mode === 1 ? this.searchShorts : this.searchShorts2}
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                            </div>
                            <div className="tableFixHeadSmall">
                                {Mode === 1 ? (
                                    <table className="table table-clean mb-0">
                                        <thead>
                                            <tr>
                                                {this.state.HeaderTable.Row1.map((col, i) => (
                                                    <th key={i} colSpan={col.span} className="text-center"
                                                        style={{ background: i % 2 === 0 ? 'linear-gradient(135deg,#0f172a,#1e3a8a)' : '#1e3a8a', color: 'white', fontWeight: 800, fontSize: '0.8rem', letterSpacing: '0.04em', padding: '6px 8px', border: 'none' }}>
                                                        {col.year}
                                                    </th>
                                                ))}
                                            </tr>
                                            <tr>
                                                <th colSpan={6} style={{ background: '#1e293b', border: 'none', padding: '5px' }}></th>
                                                {this.state.HeaderTable.Row2.map((col, i) => (
                                                    <th key={i} colSpan={3} className="text-center"
                                                        style={{ background: i % 2 === 0 ? '#1e293b' : '#334155', color: 'rgba(255,255,255,0.85)', fontWeight: 700, fontSize: '0.75rem', padding: '5px 8px', border: 'none' }}>
                                                        {col.month}
                                                    </th>
                                                ))}
                                            </tr>
                                            <tr>
                                                {this.state.HeaderTable.Row3.map((col, c) => (
                                                    col.title.map((tit, t) => (
                                                        <th key={t} onClick={() => this.OrderPriceMargins(tit, col)}
                                                            className="text-center"
                                                            style={{ cursor: tit ? 'pointer' : 'default', whiteSpace: 'nowrap' }}>
                                                            {tit}
                                                            {tit !== '' && <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>}
                                                        </th>
                                                    ))
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.BodyFilter.map((element, e) => (
                                                <tr onClick={() => this.DetailofShort(element)} key={uuidv4()} style={{ cursor: 'pointer' }}>
                                                    <td className="text-center">{e + 1}</td>
                                                    <td className="text-center">{element.ItemCode}</td>
                                                    <td className="text-center">{element.ProductLine}</td>
                                                    <td>{element.ItemCodeDesc}</td>
                                                    <td className="text-center">{element.Category}</td>
                                                    <td className="text-center">{element.Subcategory}</td>
                                                    {element.Detail.map((year) => (
                                                        year.Months.map((month) => (
                                                            month.shorts === '-' ? (
                                                                <React.Fragment key={uuidv4()}>
                                                                    <td className="text-center">-</td><td></td><td className="text-center">-</td>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment key={uuidv4()}>
                                                                    <td className="text-center">{month.QuantityShipped}</td>
                                                                    <td className="text-end">{month.dolar}</td>
                                                                    <td className="text-end">{NumberFormat(pricesFormat(month.shorts))}</td>
                                                                </React.Fragment>
                                                            )
                                                        ))
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="tfoot">
                                            <tr>
                                                <td></td><td></td><td></td><td>TOTALS</td><td></td><td></td>
                                                {this.state.Totals.map((total, t) => (
                                                    <td className={t === 0 ? 'text-center' : 'text-end'} key={t}>{total}</td>
                                                ))}
                                            </tr>
                                        </tfoot>
                                    </table>
                                ) : (
                                    <table className="table table-clean mb-0">
                                        <thead>
                                            <tr>
                                                {this.state.HeaderTable2.Row1.map((col, i) => (
                                                    <th key={i} colSpan={col.span} className="text-center"
                                                        style={{ background: i % 2 === 0 ? 'linear-gradient(135deg,#0f172a,#1e3a8a)' : '#1e3a8a', color: 'white', fontWeight: 800, fontSize: '0.8rem', letterSpacing: '0.04em', padding: '6px 8px', border: 'none' }}>
                                                        {col.year}
                                                    </th>
                                                ))}
                                            </tr>
                                            <tr>
                                                <th colSpan={9} style={{ background: '#1e293b', border: 'none', padding: '5px' }}></th>
                                                {this.state.HeaderTable2.Row2.map((col, i) => (
                                                    <th key={i} colSpan={3} className="text-center"
                                                        style={{ background: i % 2 === 0 ? '#1e293b' : '#334155', color: 'rgba(255,255,255,0.85)', fontWeight: 700, fontSize: '0.75rem', padding: '5px 8px', border: 'none' }}>
                                                        {col.month}
                                                    </th>
                                                ))}
                                            </tr>
                                            <tr>
                                                {this.state.HeaderTable2.Row3.map((col, c) => (
                                                    col.title.map((tit, t) => (
                                                        <th key={t} onClick={() => this.OrderPriceMargins2(tit, col)}
                                                            className="text-center"
                                                            style={{ cursor: tit ? 'pointer' : 'default', whiteSpace: 'nowrap' }}>
                                                            {tit}
                                                            {tit !== '' && <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>}
                                                        </th>
                                                    ))
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.BodyFilterCustomer.map((element, e) => (
                                                <tr onClick={() => this.DetailbyCustomer(element)} key={uuidv4()} style={{ cursor: 'pointer' }}>
                                                    <td className="text-center">{e + 1}</td>
                                                    <td>{element.CustomerNo}</td>
                                                    <td>{element.CustomerName}</td>
                                                    <td className="text-center">{element.AddressLine1}</td>
                                                    <td className="text-center">{element.City}</td>
                                                    <td className="text-center">{element.State}</td>
                                                    <td className="text-center">{element.ZipCode}</td>
                                                    {element.Detail.map((year) => (
                                                        year.Months.map((month) => (
                                                            month.shorts === '-' ? (
                                                                <React.Fragment key={uuidv4()}>
                                                                    <td className="text-center">-</td><td></td><td className="text-center">-</td>
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment key={uuidv4()}>
                                                                    <td className="text-center">{month.QuantityShipped}</td>
                                                                    <td className="text-end">{month.dolar}</td>
                                                                    <td className="text-end">{NumberFormat(pricesFormat(month.shorts))}</td>
                                                                </React.Fragment>
                                                            )
                                                        ))
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="tfoot">
                                            <tr>
                                                <td></td><td></td><td>TOTALS</td><td></td><td></td><td></td><td></td>
                                                {this.state.Totals.map((total, t) => (
                                                    <td className={t === 0 ? 'text-center' : 'text-end'} key={t}>{total}</td>
                                                ))}
                                            </tr>
                                        </tfoot>
                                    </table>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {!hasData && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', opacity: 0.3, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                        </div>
                    )}
                </div>

                {/* Detail modal */}
                <ModalOrders
                    title={Mode === 1
                        ? 'Sales of Item: ' + this.state.currentItem.ItemCode
                        : 'Sales of Customer: ' + this.state.currentCustomer.CustomerName}
                    show={this.state.showModal1}
                    close={(modal = "showModal1") => this.handleModalClose(modal)}
                >
                    {Mode === 1 ? (
                        <div className="col-12">
                            <div className="row d-flex justify-content-center mb-3">
                                <div className="col-sm-6 col-lg-4 text-center">
                                    <img key={this.state.currentItem.itemURL} className="pb-3 pt-3"
                                        style={{ maxHeight: '160px', objectFit: 'contain' }}
                                        src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'}
                                        alt="ProductImg" />
                                </div>
                                <div className="col-sm-6 col-lg-5 d-flex flex-column justify-content-center gap-2">
                                    <div>
                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700, marginRight: '0.5rem' }}>{this.state.currentItem.ItemCode}</span>
                                        <span style={{ background: 'rgba(139,92,246,0.08)', color: '#5b21b6', border: '1px solid #DDD6FE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700 }}>{this.state.currentItem.ProductLine}</span>
                                    </div>
                                    <p style={{ color: '#334155', fontWeight: 600, margin: 0 }}>{this.state.currentItem.ItemCodeDesc}</p>
                                </div>
                                <div className="col-sm-6 col-lg-3 d-flex align-items-center justify-content-end">
                                    <ExcelDocument
                                        archname={'Sales Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                        sheetname={'Shorts Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                        data={getDataSet(this.state.ShortDetailWithTotal,
                                            ['Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'],
                                            ['SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD']
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th>SO No</th><th>Invoice No</th><th>Type</th>
                                            <th>Customer No</th><th>Customer Name</th><th>Price Level</th>
                                            <th>Salesperson</th><th>Route</th><th>Date</th>
                                            <th>Qty Ordered</th><th>Qty Shipped</th>
                                            <th>Category</th><th>Subcategory</th>
                                            <th>Unit Cost</th><th>Unit Price</th><th>Total Sales</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ShortDetail.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{item.SalesOrderNo}</td>
                                                <td className="text-center">{item.InvoiceNo}</td>
                                                <td className="text-center">{item.InvoiceType}</td>
                                                <td className="text-center">{item.CustomerNo}</td>
                                                <td>{item.BillToName}</td>
                                                <td className="text-center">{item.PriceLevel}</td>
                                                <td className="text-center">{item.SalespersonNo}</td>
                                                <td>{item.UDF_RUTA}</td>
                                                <td className="text-center">{new Date(item.InvoiceDate).toLocaleDateString('en-US')}</td>
                                                <td className="text-center">{NumberFormat(item.QuantityOrdered)}</td>
                                                <td className="text-center">{NumberFormat(item.QuantityShipped)}</td>
                                                <td className="text-center">{item.Category}</td>
                                                <td className="text-center">{item.Subcategory}</td>
                                                <td className="text-center">{NumberFormat(item.UnitCost)}</td>
                                                <td className="text-center">$ {NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                <td className="text-center">$ {NumberFormat(pricesFormat(item.shorts))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={7}></td>
                                            <td>TOTAL</td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityOrdered))}</td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityShipped))}</td>
                                            <td colSpan={3}></td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(this.state.currentItem.totalShorts))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <div style={{ background: '#F8FAFC', borderRadius: '8px', padding: '0.5rem 1rem', border: '1px solid #E2E8F0' }}>
                                            <span style={{ fontSize: '0.72rem', color: '#64748B', fontWeight: 700, textTransform: 'uppercase' }}>Customer No</span>
                                            <div style={{ fontWeight: 700, color: '#0F172A' }}>{this.state.currentCustomer.CustomerNo}</div>
                                        </div>
                                        <div style={{ background: '#F8FAFC', borderRadius: '8px', padding: '0.5rem 1rem', border: '1px solid #E2E8F0' }}>
                                            <span style={{ fontSize: '0.72rem', color: '#64748B', fontWeight: 700, textTransform: 'uppercase' }}>Customer Name</span>
                                            <div style={{ fontWeight: 700, color: '#0F172A' }}>{this.state.currentCustomer.CustomerName}</div>
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            <ExcelDocument
                                                archname={'Sales Customer ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                                sheetname={'Sales ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName)}
                                                data={getDataSet(this.state.ShortDetailWithTotal,
                                                    ['Sales Order No', 'Invoice No', 'Item Code', 'Description', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'],
                                                    ['SalesOrderNo', 'InvoiceNo', 'ItemCode', 'ItemCodeDesc', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD']
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th>SO No</th><th>Invoice No</th><th>Type</th>
                                            <th>Item Code</th><th>Description</th><th>Price Level</th>
                                            <th>Salesperson</th><th>Route</th><th>Date</th>
                                            <th>Qty Ordered</th><th>Qty Shipped</th>
                                            <th></th><th>Unit Price</th><th></th><th>Total Sales($)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.CustomerDetail.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{item.SalesOrderNo}</td>
                                                <td className="text-center">{item.InvoiceNo}</td>
                                                <td className="text-center">{item.InvoiceType}</td>
                                                <td className="text-center">{item.ItemCode}</td>
                                                <td>{item.ItemCodeDesc}</td>
                                                <td className="text-center">{item.PriceLevel}</td>
                                                <td className="text-center">{item.SalespersonNo}</td>
                                                <td>{item.UDF_RUTA}</td>
                                                <td className="text-center">{DateFormatMAS90(item.InvoiceDate)}</td>
                                                <td className="text-center">{NumberFormat(item.QuantityOrdered)}</td>
                                                <td className="text-center">{NumberFormat(item.QuantityShipped)}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(item.shorts))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={7}></td>
                                            <td>TOTAL</td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityOrdered))}</td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityShipped))}</td>
                                            <td></td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(this.state.currentCustomer.totalShorts))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )}
                </ModalOrders>
            </div>
        )
    }
}
